
const MOBILE_SOURCES = [
  { width: 400, quality: 85 },
  { width: 600, quality: 80 },
  { width: 800, quality: 75 },
]
const MOBILE_FALLBACK_WIDTH = 600
const DESKTOP_WIDTH = 900
const DESKTOP_QUALITY = 90

export default {
  data() {
    return {
      slides: [],
      secondarySlidesReady: false,
    }
  },
  async fetch() {
    try {
      const response = await this.$sliderService.fetchHome()
      this.slides = response.data
    } catch (e) {
      this.slides = []
    }
  },
  mounted() {
    const reveal = () => {
      this.secondarySlidesReady = true
    }
    if (window.requestIdleCallback) {
      window.requestIdleCallback(reveal, { timeout: 2000 })
    } else {
      window.setTimeout(reveal, 1500)
    }
  },
  methods: {
    isVisible(index) {
      return index === 0 || this.secondarySlidesReady
    },
    slideLabel(slide) {
      return slide.name || this.$t('components.mainSlider.altText')
    },
    mobileCrop(slide, width, quality) {
      return this.$cropUrl(
        slide.image_mobile,
        width,
        width,
        slide.image_mobile.extension,
        quality
      )
    },
    mobileSrc(slide) {
      const fallback = MOBILE_SOURCES.find(
        source => source.width === MOBILE_FALLBACK_WIDTH
      )
      return this.mobileCrop(slide, fallback.width, fallback.quality)
    },
    mobileSrcset(slide) {
      return MOBILE_SOURCES.map(
        source =>
          `${this.mobileCrop(slide, source.width, source.quality)} ${
            source.width
          }w`
      ).join(', ')
    },
    desktopSrc(slide) {
      return this.$cropUrl(
        slide.image,
        DESKTOP_WIDTH,
        0,
        slide.image.extension,
        DESKTOP_QUALITY
      )
    },
  },
  head() {
    const firstSlide = this.slides && this.slides.length ? this.slides[0] : null
    if (!firstSlide) {
      return {}
    }

    if (this.$device.isMobile) {
      if (!firstSlide.image_mobile) {
        return {}
      }
      return {
        link: [
          {
            hid: 'preload-main-slider',
            rel: 'preload',
            as: 'image',
            href: this.mobileSrc(firstSlide),
            imagesrcset: this.mobileSrcset(firstSlide),
            imagesizes: '100vw',
            fetchpriority: 'high',
          },
        ],
      }
    }

    if (!firstSlide.image) {
      return {}
    }
    return {
      link: [
        {
          hid: 'preload-main-slider',
          rel: 'preload',
          as: 'image',
          href: this.desktopSrc(firstSlide),
          fetchpriority: 'high',
        },
      ],
    }
  },
}
